var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reMain" },
    [
      _c("RealTitle", { attrs: { titleInfo: _vm.titleInfo } }),
      _vm._v(" "),
      _c("Navs", {
        attrs: {
          type: "4",
          placeholder: "请输入书名/ISBN/作者",
          neednavs: true,
        },
        on: {
          majorId: _vm.getMajorId,
          lookAtAll: _vm.lookAtAll,
          setsearchdata: _vm.setsearchdata,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "course-box" },
        [
          _vm.bookList.length <= 0
            ? _c("div", { staticClass: "noarr" }, [_vm._v("暂无数据")])
            : _vm._l(_vm.bookList, function (item, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "course-item",
                    on: {
                      click: function ($event) {
                        return _vm.lookDetails(item)
                      },
                    },
                  },
                  [_c("NumCard", { attrs: { i: item } })],
                  1
                )
              }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "paginationX" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "page-size": _vm.pageSize,
              layout: "prev, pager, next",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }